export enum DecoratorType {
    NONE = "none",
    LIST = "list",
    ADD = "add",
    SEARCH = "search",
    UPDATE = "update",
    ADVANCED = "advanced",
    REPORT = "report"
}
